import React from 'react';
import { btnTypes } from '../../../../../../../../components/btn';
import ActionBtn from '../ActionBtn';
import styles from './index.module.scss';

const Content = ({ onOk, onReset, children }) => {
  return (
    <div className={styles.content}>
      <div className={styles.body}>{children}</div>

      <div className={styles.actions}>
        <ActionBtn type={btnTypes.primary} onClick={onOk}>
          Применить
        </ActionBtn>
        <ActionBtn type={btnTypes.secondary} onClick={onReset}>
          Сбросить
        </ActionBtn>
      </div>
    </div>
  );
};

export default Content;
